import { createApiHandler } from './handler';

const audit = {
  apiClient: null,
  path: '/admin/audit',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  /**
   * Retrieve all audit sections in one response.
   * @param {object} params - { threshold?: number (default 10), days?: number (default 30) }
   */
  async getPlansAudit(params = {}) {
    try {
      const response = await this.apiClient.get(`${this.path}/plans`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default audit;
